import {IconFillingColoured, IconTemperatureColoured} from "site-apps/assets/AssetColorsIcons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const TabPreviewTableAssetsOut = ({assetsOut}) => {
    return (
        <table className="table table-striped">
            <thead>
                <tr>
                    <th>Contenedor</th>
                    <th></th>
                    <th style={{width: "80px", textAlign: "center"}}>Nivel</th>
                    <th>Motivo</th>
                    <th style={{width: "65px", textAlign: "center"}}>Minutos</th>
                </tr>
            </thead>
            <tbody>
                {assetsOut.map((item, index) => (
                    <tr key={index}>
                        <td>
                            <div>{item.asset.uid} </div>
                            <div className="text-muted">{item.asset.island_id && `(${item.asset.island_name})`}</div>
                            <div>{item.asset.full_address}</div>
                            <small>{item.asset.uuids}</small>
                        </td>
                        <td className="text-end">
                            <div>-</div>
                            <div>
                                <IconTemperatureColoured value={item.asset.temperature} />
                            </div>
                            <div>
                                {item.asset.has_device ? (
                                    <FontAwesomeIcon icon="wifi" title="Tiene sensor" className="text-secondary me-2" />
                                ) : (
                                    <></>
                                )}
                                {item.asset.has_route ? (
                                    <FontAwesomeIcon icon="truck-fast" title="Tiene Ruta" className="text-secondary" />
                                ) : (
                                    <></>
                                )}
                            </div>
                        </td>
                        <td className="text-end">
                            <div>
                                <IconFillingColoured value={item.asset.filling} />
                            </div>
                        </td>
                        <td className="small">{item.reason}</td>
                        <td className="text-center">
                            <div>
                                {item.step}/{item.time}
                            </div>
                            <div>
                                {item.accepted ? (
                                    <FontAwesomeIcon icon="circle" className="text-success" title="Aceptado" />
                                ) : (
                                    <FontAwesomeIcon icon="circle" className="text-danger" title="Rechazado" />
                                )}
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};
export default TabPreviewTableAssetsOut;
